import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import CollectRouteTask from './components/collect-route-task/collect-route-task.vue'
import AcceptRouteTask from './components/accept-route-task/accept-route-task.vue'
import debounce from 'lodash.debounce'
import Masonry from 'masonry-layout'


export default {
  name: 'collectOrders',
  components: {
    FixFluidColGrid,
    CollectRouteTask,
    AcceptRouteTask
  },

  static() {
    return {
      masonryObj: null
    }
  },
  
  computed: {
    ...mapState({
      state: state => state,

      collectSocket: state => state.collectOrders.collectSocket,
      collectRouteTasks: state => state.collectOrders.collectRouteTasks,

      acceptSocket: state => state.collectOrders.acceptSocket,
      acceptRouteTasks: state => state.collectOrders.acceptRouteTasks,

      remakeSocket: state => state.collectOrders.remakeSocket,
      remakeRouteTasks: state => state.collectOrders.remakeRouteTasks,

      activeSockets: state => state.collectOrders.activeSockets,

      inProgressRemakingTasks() {
        return Object.values(this.remakeRouteTasks.remaking).filter(routeTask => {
          return routeTask.status === 'in_progress'
        })
      },

      doneRemakingTasks() {
        return Object.values(this.remakeRouteTasks.remaking).filter(routeTask => {
          return routeTask.status === 'done'
        })
      },

      collectedCountData() {
        return this.getCountData(this.collectRouteTasks)
      }
      
    }),

    ...mapGetters({
      actionTasksCount: 'collectOrders/actionTasksCount'
    })
  },

  mounted() {
    this.setConnections()
  },

  beforeDestroy() {

    this.closeConnection('collect')

    if (this.masonryObj) {
      this.masonryObj.destroy()
    }

    this.setCollectRouteTask({})
  },

  methods: {
    ...mapActions({
      setCollectConnection: 'collectOrders/setCollectConnection',
      setRemakeConnection: 'collectOrders/setRemakeConnection'
    }),

    ...mapMutations({
      setCollectRouteTask: 'collectOrders/SET_COLLECT_ROUTE_TASKS',
      removeActiveSocket: 'collectOrders/REMOVE_ACTIVE_SOCKET',
    }),

    setConnections() {
      this.setCollectConnection()
    },

    closeConnection(nameConnection) {
      const socketConnection = this[`${nameConnection}Socket`]
      socketConnection.close()
      this.removeActiveSocket(this.state, socketConnection)
    },

    refreshCollected: debounce(function() {
      this.closeConnection('collect')
      this.setCollectConnection()
    }, 300, {
      leading: true,
      trailing: false
    }),

    refreshAccepted: debounce(function() {
      this.closeConnection('accept')
      this.closeConnection('remake')
      this.setRemakeConnection()
    }, 300, {
      leading: true,
      trailing: false
    }),

    getCountClassColor(count) {
      if (count >= 0 && count <= 2) {
        return 'min'
      }

      if (count >= 3 && count <= 4) {
        return 'middle'
      }

      return 'many'
    },

    getCountData(object) {
      const count = Object.values(object).length
      return {
        count,
        className: this.getCountClassColor(count)
      }
    }
  },

  watch: {
    collectRouteTasks() {
      this.$nextTick(() => {
        if (this.masonryObj) {
          this.masonryObj.reloadItems()
          this.masonryObj.layout()
        } else {
          this.masonryObj = new Masonry(this.$refs['masonry-grid'], {
            itemSelector: '.collect-route-task',
            gutter: 15
          })
        }
      })
    }
  }
}